/**
 * marcas.service.js — Busca as marcas de veículos via Edge Function pública.
 * Edge Function: public-marcas
 * Retorna: { ok: true, marcas: [{ id, nome }] }
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const ANON_KEY     = import.meta.env.VITE_SUPABASE_ANON_KEY;

const MARCAS_API_URL = `${SUPABASE_URL}/functions/v1/public-marcas`;

const _headers = ANON_KEY
  ? {
      'apikey':        ANON_KEY,
      'Authorization': `Bearer ${ANON_KEY}`,
      'Content-Type':  'application/json',
    }
  : {};

/**
 * Busca todas as marcas cadastradas (ordenadas por nome).
 * @param {string} [q] - Filtro opcional por nome (ilike).
 * @returns {Promise<{ data: Array<{id:string, nome:string}> | null, error: string | null }>}
 */
export async function fetchMarcas(q = '') {
  try {
    const url = new URL(MARCAS_API_URL);
    if (q) url.searchParams.set('q', q);

    const res = await fetch(url.toString(), { headers: _headers });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const json = await res.json();
    return { data: json.marcas ?? [], error: null };
  } catch (err) {
    console.error('[marcas.service]', err);
    return { data: null, error: err.message };
  }
}
